<template>
  <div class="m-15">
    <b-row>
      <b-col xl="12" md="12" lg="12" sm="12" class="mt-3">
        <b-card header-tag="header" style="font-weigth=fsbold">
          <template slot="header">
            <b-row>
              <b-col cols="12">
                <h5 class="float-center">
                  <strong>Configurações</strong>
                </h5>
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col cols="12" lg="6" class="mt-3">
              <table class="update-table">
                <tbody>
                  <tr>
                    <td class="mw67">
                      <c-switch
                        class="mx-1"
                        v-model="havePush"
                        color="success"
                        checked
                        variant="3d"
                        @change="onChangePush"
                      />
                    </td>
                    <td>
                      <span>
                        &nbsp;
                        <strong>Enviar push</strong>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>

            <b-col cols="12" lg="6" class="mt-3">
              <b-col cols="12">
                <b-input-group prepend="Título">
                  <b-form-input
                    id="Titulo"
                    v-model="titulo"
                    placeholder="ex: Sorteio - Incrível produto"
                    @keyup.enter="focus('Descrição')"
                    @keyup="onChanged"
                  />
                </b-input-group>
              </b-col>
              <b-col cols="12">
                <b-input-group prepend="Descrição" class="mt-3">
                  <b-form-input
                    id="Descrição"
                    v-model="descricao"
                    placeholder="ex: Compras a partir de R$10"
                    @keyup.esc="focus('Titulo')"
                    @keyup="onChanged"
                  />
                </b-input-group>
              </b-col>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";

export default {
  name: "inserirpromocaoconfiguracoes",
  components: {
    cSwitch,
  },
  data: function () {
    return {
      havePush: false,
      haveEmail: false,
      titulo: "",
      descricao: "",
    };
  },
  methods: {
    setLocalStorage() {
      localStorage.setItem("titulo", this.titulo);
      localStorage.setItem("descricao", this.descricao);
    },
    focus(id) {
      document.getElementById(id).focus();
    },
    onChanged() {
      if (this.titulo != "" && this.descricao != "") {
        this.setLocalStorage();
        this.$emit("can-continue", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    },
    onChangePush() {
      localStorage.setItem("have-push", this.havePush);
      this.focus('Titulo');
    },
  },
  mounted() {
    this.havePush = false;
    this.haveEmail = false;
    localStorage.setItem("have-push", this.havePush);
  },
};
</script>
